import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-table/react-table.css'
import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'emotion-theming'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router/immutable'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import store from 'store'
import { Global } from '@emotion/core'
import { getGlobalStyles } from 'utils/styles'
import { initialize as initializeAnalytics } from 'utils/analytics'
import { setup as setupLogging } from 'utils/logging'
import { NODE_ENV_PRODUCTION } from 'utils/constants'
import { AuthProvider } from 'auth'
import App from './App'
import history from './history'
import setTheme from './theme'

setupLogging()
initializeAnalytics()

const theme = setTheme()

const renderApp = () => {
  ReactDOM.render(
    <AuthProvider>
      <Provider store={store}>
        <Global styles={getGlobalStyles(theme)} />
        <DndProvider backend={HTML5Backend}>
          <ConnectedRouter history={history}>
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          </ConnectedRouter>
        </DndProvider>
      </Provider>
    </AuthProvider>,
    document.getElementById('root')
  )
}

renderApp()

if (process.env.NODE_ENV !== NODE_ENV_PRODUCTION) {
  if (module.hot) {
    module.hot.accept('App', renderApp)
  }
}
